<template>
  <section class="section with-min-height">
    <div class="container" v-if="!loader.isLoading && !hasDocuments">
      <h1>Your Documents</h1>
      <div class="documents">
        <div v-if="data && data.status !== 500">
          <p>
            Your link has expired, please
            <router-link to="/account/my-policy">click here</router-link> to
            retrieve your documents again.
          </p>
        </div>
        <div v-else>
          <p>
            We were unable to locate any policy documents associated with your
            e-mail address. If you believe this is an error, please contact our
            Customer Concierge team at your earliest convenience.
          </p>
          <p>
            Our Customer Concierge team is available Monday through Friday from
            9am to 5pm to help you submit a quote, change a policy, or anything
            else you might need.
          </p>
          <p>
            You can reach us at
            <span style="white-space: nowrap;"
              ><a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a></span
            >
            or email us at
            <span style="white-space: nowrap;"
              ><a href="mailto:customercare@porscheautoinsurance.com"
                >customercare@porscheautoinsurance.com</a
              ></span
            >
          </p>
        </div>
      </div>
      <div class="documents">
        <p>
          We are either unable to locate your account details, or your document
          link has expired.
        </p>
        <p>
          If you believe this is an error, our Customer Concierge team is
          available to assist you Monday through Friday, 9AM to 5PM.
        </p>
        <p>
          You can reach us at
          <span style="white-space: nowrap;"
            ><a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a></span
          >
          or email us at
          <span style="white-space: nowrap;"
            ><a href="mailto:customercare@porscheautoinsurance.com"
              >customercare@porscheautoinsurance.com</a
            ></span
          >
        </p>
      </div>
    </div>
    <Onboarding
      class="container"
      v-else-if="isOnboarding && hasDocuments"
      :token="token"
      :data="data"
      :documents="documents"
    />
    <Docs
      class="container"
      v-else-if="!isOnboarding && hasDocuments"
      :token="token"
      :data="data"
      :documents="documents"
    />
    <div class="container" v-else>
      Locating your account details...
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Onboarding from '@/pages/account/Onboarding';
import Docs from '@/pages/account/Docs';

export default {
  name: 'Documents',
  components: { Docs, Onboarding },
  props: {
    token: {
      type: String,
      required: true
    }
  },
  beforeMount() {
    this.toggleLoader({
      loaderText: 'Loading your account details...'
    });
    this.requestDocsLinks({
      token: this.token
    })
      .then(res => {
        this.data = res;
        this.toggleLoader({
          close: true
        });

        const typeEnum = {
          ID_CARD: 'card',
          DEC_PAGE: 'declaration',
          ESIGN: 'esignature',
          ODOMETER: 'odometer'
        };

        let rawDocs = res.data.documents.map(doc => {
          return {
            name: doc.fileDescription,
            url: doc.fileUrl,
            type:
              (doc.fileDescription.toLowerCase().includes('declaration') &&
                typeEnum.DEC_PAGE) ||
              (doc.fileDescription.toLowerCase().includes('esignature') &&
                typeEnum.ESIGN) ||
              (doc.fileDescription.toLowerCase().includes('card') &&
                typeEnum.ID_CARD) ||
              (doc.fileDescription.toLowerCase().includes('odometer') &&
                typeEnum.ODOMETER),
            date: doc.dateCreated || Date.now()
          };
        });
        let idCards = rawDocs
          .filter(c => {
            return c.type === typeEnum.ID_CARD;
          })
          .sort((a, b) => {
            new Date(b.date) - new Date(a.date);
          });
        if (idCards.length > 0 && !this.documents.includes(idCards[0])) {
          this.documents.push(idCards[0]);
        }
        let decPages = rawDocs
          .filter(d => {
            return d.type === typeEnum.DEC_PAGE;
          })
          .sort((a, b) => {
            new Date(b.date) - new Date(a.date);
          });
        if (decPages.length > 0 && !this.documents.includes(decPages[0])) {
          this.documents.push(decPages[0]);
        }
        let odoLinks = rawDocs
          .filter(d => {
            return d.type === typeEnum.ODOMETER;
          })
          .sort((a, b) => {
            new Date(b.date) - new Date(a.date);
          });
        if (odoLinks.length > 0 && !this.documents.includes(odoLinks[0])) {
          this.documents.push(odoLinks[0]);
        }
        let esignLinks = rawDocs
          .filter(d => {
            return d.type === typeEnum.ESIGN;
          })
          .sort((a, b) => {
            new Date(b.date) - new Date(a.date);
          });
        if (esignLinks.length > 0 && !this.documents.includes(esignLinks[0])) {
          this.documents.push(esignLinks[0]);
        }
        if (
          this.documents.length > 0 &&
          (this.documents.filter(d => d.type === 'odometer').length > 0 ||
            this.documents.filter(d => d.type === 'esignature').length > 0)
        ) {
          this.isOnboarding = true;
        }
      })
      .catch(e => {
        console.error(e);
        this.documents = [];
        this.toggleLoader({
          close: true
        });
      });
  },
  data: () => ({
    isOnboarding: false,
    documents: [],
    data: {
      status: 404,
      result: {}
    }
  }),
  methods: {
    ...mapActions(['requestDocsLinks']),
    ...mapMutations(['toggleLoader'])
  },
  computed: {
    ...mapGetters(['loader']),
    hasDocuments() {
      return this.documents && this.documents.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
p.instruction {
  text-align: center;
}
.documents {
  display: flex;
  justify-content: center;
}
span.card {
  cursor: pointer;
  color: $black;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  padding: 15px;
  margin: 5px;
  max-width: 175px;
  border-radius: 15px;
  border: solid 2px $black;

  p {
    margin: 1em 0 0;
  }
}
span.icon {
}
</style>
